import { render } from "./InvoicesStatusWidget.vue?vue&type=template&id=842cd2fc"
import script from "./InvoicesStatusWidget.vue?vue&type=script&lang=js"
export * from "./InvoicesStatusWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__